export function BrandMarquee({ items, reverse = false, label }) {
  return (
    <div className="brand-marquee-row" role="group" aria-label={label}>
      <div className={`brand-marquee-track${reverse ? " reverse" : ""}`}>
        {[false, true].map((copy) => (
          <ul className="brand-marquee-group" key={String(copy)} aria-hidden={copy || undefined}>
            {items.map((brand) => (
              <li className="brand-logo-card" key={brand.name}>
                <img
                  className={brand.monochrome ? "brand-logo-monochrome" : undefined}
                  src={brand.src}
                  alt={copy ? "" : brand.name}
                  width={brand.width}
                  height={brand.height}
                  decoding="async"
                  fetchPriority="low"
                  draggable="false"
                />
              </li>
            ))}
          </ul>
        ))}
      </div>
    </div>
  );
}
